module.exports = __webpack_public_path__ + "img/setting.327540b4.png";